export default __webpack_public_path__ + "static/media/algorithm-flow.01f9b4bc.png";